import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button } from '@xiltrion/ui/button';
import { Icono } from '@xiltrion/ui/icono';
import { Spinner } from '@xiltrion/ui/spinner';
import { apiPost } from '@/api/client';
import { confirm, notify, notifyError } from '@/features/config/shared';
import { wfKeys } from './api';

/**
 * Flujo base (`BASE_WORKFLOW_CODES`): vuelve a publicar su definición inicial, por si se modificó mal o ya no sirve
 * como quedó. Reemplaza el borrador que hubiera; los casos en curso siguen como iban.
 */
export function RestoreBaseButton({ workflowId, name, onRestored, size = 'sm' }: { workflowId: string; name: string; onRestored?: (versionId: string) => void; size?: 'sm' | 'xs' }) {
  const qc = useQueryClient();
  const restore = useMutation({
    mutationFn: () => apiPost<{ ok: boolean; versionId: string }>(`/workflows/${workflowId}/restore-base`),
    onSuccess: async (r) => {
      await qc.invalidateQueries({ queryKey: wfKeys.detail(workflowId) });
      void qc.invalidateQueries({ queryKey: wfKeys.list });
      notify('success', 'Flujo restablecido', 'Los casos nuevos usan otra vez la versión base.');
      onRestored?.(r.versionId);
    },
    onError: notifyError,
  });
  const ask = async () => {
    const ok = await confirm({
      header: 'Restablecer la versión base',
      message: `«${name}» volverá a quedar como venía de fábrica y se publicará así para los casos nuevos. Se pierden los cambios del borrador. Los casos en curso siguen como iban.`,
      acceptLabel: 'Restablecer', danger: true,
    });
    if (ok) restore.mutate();
  };
  return (
    <Button variant="outline" size={size} disabled={restore.isPending} onClick={() => void ask()}>
      {restore.isPending ? <Spinner /> : <Icono nombre="mdi:backup-restore" />} Restablecer versión base
    </Button>
  );
}
